import Axios, { AxiosInstance } from 'axios';
import EndpointFactory from 'axios-endpoints';

const url = process.env.VUE_APP_WS_EMPIRICUS as string;
const API: AxiosInstance = Axios.create();

const Endpoint = EndpointFactory(API);

export const verifyEmailEndpoint = new Endpoint<{}>(url);
